import React, { useEffect, useState } from "react";
import { FaPenToSquare, FaCheck, FaX } from "react-icons/fa6";
import { toast } from "react-toastify";
import "../../pages/user/css/Curriculum.css";
import { API_BASE_URL, API_ciudadanos } from "../../config/apiConfig";

const Estados = ({ usuario, setUsuario }) => {
  // Estado del usuario (Activo/Inactivo)
  const [usuarioActivo, setUsuarioActivo] = useState("");
  const [tempUsuarioActivo, setTempUsuarioActivo] = useState("");

  // Estado laboral (Trabajando/Desempleado)
  const [estadoLaboral, setEstadoLaboral] = useState("");
  const [tempEstadoLaboral, setTempEstadoLaboral] = useState("");

  const [editEstado, setEditEstado] = useState(false);
  const [editLaboral, setEditLaboral] = useState(false);

  // Cargar los datos cuando se recibe el usuario
  useEffect(() => {
    if (usuario) {
      setUsuarioActivo(usuario.estadoUsuario || "Activo");
      setTempUsuarioActivo(usuario.estadoUsuario || "Activo");

      setEstadoLaboral(usuario.estadoLaboral || "Desempleado");
      setTempEstadoLaboral(usuario.estadoLaboral || "Desempleado");
    }
  }, [usuario]);

  // Color para el circulo del estado de usuario
  const getColorByEstado = (estado) => {
    switch (estado.toLowerCase()) {
      case "activo":
        return "#3c4a99";
      case "inactivo":
        return "#8E151D";
      case "pendiente":
        return "#da8d00";
      default:
        return "#3c4a99"; // color por defecto
    }
  };

  // Editar Estado del usaurio (Activo/Inactivo)
  const handleGuardarEstado = async () => {
    const body = { estadoUsuario: tempUsuarioActivo };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/cambiarEstado`, {
        method: "PATCH", // en lugar de PATCH
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ estadoUsuario: tempUsuarioActivo }),
      });

      if (!res.ok) throw new Error("Error al cambiar el estado");

      setUsuarioActivo(tempUsuarioActivo);
      setEditEstado(false);

      // ✅ Actualizar el estado del usuario en el componente padre
      if (setUsuario) {
        setUsuario((prevUsuario) => ({
          ...prevUsuario,
          estadoUsuario: tempUsuarioActivo,
        }));
      }

      toast.success("Estado actualizado correctamente");
    } catch (error) {
      console.error("❌ Error al guardar estado:", error);
      toast.error("Error al cambiar el estado del usuario");
    }
  };

  // Editar Estado del usuario  (Trabajando/Desempleado)
  const handleGuardarEstadoLaboral = async () => {
    const body = { estadoLaboral: tempEstadoLaboral };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Error al actualizar estado laboral");
      console.log(await res.json(), "updatedUser");
      setEstadoLaboral(tempEstadoLaboral);
      setEditLaboral(false);

      // ✅ Actualizar el estado laboral en el componente padre
      if (setUsuario) {
        setUsuario((prevUsuario) => ({
          ...prevUsuario,
          estadoLaboral: tempEstadoLaboral,
        }));
      }

      toast.success("Estado laboral actualizado correctamente");
    } catch (error) {
      console.error("❌ Error al guardar estado laboral:", error);
      toast.error("Error al actualizar estado laboral");
    }
  };

  return (
    <div className="estado-conexion">
      {/* Estado del usuario */}
      <div className="align-center gap-5">
        <span className="estado" style={{ backgroundColor: getColorByEstado(usuarioActivo) }}></span>
        {editEstado ? (
          <>
            <select value={tempUsuarioActivo} onChange={(e) => setTempUsuarioActivo(e.target.value)} aria-label="Estado del usuario">
              <option value="Activo">Activo</option>
              <option value="Inactivo">Inactivo</option>
            </select>
            <div className="check flex gap-5 ml-5">
              <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={handleGuardarEstado}>
                <FaCheck />
              </button>
              <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => setEditEstado(false)}>
                <FaX />
              </button>
            </div>
          </>
        ) : (
          <>
            Usuario {usuarioActivo}
            {/* Botón editar estado del usuario */}
            <button aria-label="Editar estado del usuario" className="fondo-blanco negro ml-5 edicion" onClick={() => setEditEstado(true)}>
              <FaPenToSquare />
            </button>
          </>
        )}
      </div>

      {/* Estado laboral */}
      <div className="ultima-conexion align-center gap-5">
        <strong>Estado laboral:</strong>
        {editLaboral ? (
          <>
            <select
              value={tempEstadoLaboral}
              onChange={(e) => setTempEstadoLaboral(e.target.value)}
              aria-label="Estado laboral del usuario"
            >
              <option value="Desempleado">Desempleado</option>
              <option value="Trabajando">Trabajando</option>
            </select>
            <div className="check flex gap-5 ml-5">
              <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={handleGuardarEstadoLaboral}>
                <FaCheck />
              </button>
              <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => setEditLaboral(false)}>
                <FaX />
              </button>
            </div>
          </>
        ) : (
          <>
            {estadoLaboral}
            {/* Botón editar estado laboral */}
            <button aria-label="Editar estado laboral" className="fondo-blanco negro ml-5 edicion" onClick={() => setEditLaboral(true)}>
              <FaPenToSquare />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Estados;
